import {regReducer, dispatch} from '../../core';
import * as actions from './actions';
import * as s from './selectors';
import * as f from './functions';
import * as r from 'ramda';

export const MODE_ONE_HALF = 'one';
export const MODE_TWO_HALVES = 'two';

regReducer(actions.INIT, (state, {payload}) => {
    return payload;
});

(() => {
    let arr = [];
    let push = (mode, id) => {
        if (Array.isArray(id)) {
            arr = id;
            return 0;
        }
        if (mode === MODE_ONE_HALF) {
            arr[0] = id;
        } else if (mode === MODE_TWO_HALVES) {
            if (arr.length === 2) {
                arr = [id];
            } else {
                arr.push(id);
            }
        }
    };

    regReducer(actions.SELECT_PIZZA, (state, {payload}) => {
        push(s.selectMode(state), payload);
        f.updateUrl(arr);
        f.updateFormInput(s.selectFormInput(state), arr);
        let newModalId = f.getNewModalId(s.selectMode(state), arr.length);
        let newState = Object.assign({}, state);
        s.halfPizzaConfiguration(newState).pizzas = r.map((pizza) => {
            let newPizza = Object.assign({}, pizza);
            newPizza.selected = arr.indexOf(pizza.id) > -1;
            return newPizza;
        }, s.halfPizzaConfiguration(newState).pizzas);

        if (newModalId !== undefined) {
            s.selectSubmitButtonModalConfig(newState).submitButtonModalId =
                newModalId;
        }

        s.halfPizzaConfiguration(newState).images =
            f.getImagesFromSelectedPizzas(arr);

        return newState;
    });
})();

regReducer(actions.TOGGLE_CATEGORY, (state, {payload}) => {
    let newState = Object.assign({}, state);
    let newCategories = s
        .halfPizzaConfiguration(newState)
        .categories.map((category) => {
            category.active = payload === category.id;
            return Object.assign({}, category);
        });
    s.halfPizzaConfiguration(newState).categories = newCategories;
    return newState;
});
